import React from 'react';
import additional from './value_color.svg'

const Value_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Value_color;
